<template>
  <div class="order-wrapper">
    <div class="order_success order_success_o order-result">
      <div v-if="result > 0">
        <img alt class="order-result-icon" src="@/assets/images/html/success_03.png">
        <div class="order-result-msg">
          <div class="one">
            <span>订单收款成功！</span>
          </div>
        </div>
      </div>
      <div class="order-result-error" v-else>
        <img alt class="order-result-icon" src="@/assets/images/html/fail.png">
        <div class="order-result-msg">
          <div class="one">
            <span>订单收款失败！请联系管理员！</span>
          </div>
        </div>
        <div class="order-result-error-button">
          <a @click="$router.go(-1)" href="javascript:void(0);">
            <span>返回</span>
          </a>
        </div>
      </div>
      <div class="order-result-bottom" v-if="result > 0">
        <div class="order-result-route-info">
          <div>
            <div class="one overflow-ellipsis-line1">
              <span>产品名称：</span>
              <em>{{plan_info.route_plan_name}}</em>
            </div>
            <div class="tow">
              <span>订单编号：</span>
              <em>{{order_info.order_info_id}}</em>
            </div>
            <a
              @click="$pushByName('agentOrderDetail',{order_id: order_id})"
              href="javascript:void(0);"
            >
              <em>查看订单详情</em>
              <img alt src="~@/assets/images/html/blue_arrow_07.png">
            </a>
          </div>
          <div>
            <div class="one order-result-userinfo" style="width:300px;">
              <span>下单人：</span>
              <em>{{user_info.name}}</em>
              <a :href="'tel:' + user_info.cell" class="tel">
                <img alt="电话号码" class="user-tel" src="@/assets/images/html/call_03.png">
                <span>{{user_info.cell}}</span>
              </a>
            </div>
            <div class="tow order-result-userinfo" style="width:370px;">
              <span>联系人：</span>
              <em>{{order_info.contact_person}}</em>
              <a :href="'tel:' + order_info.contact_tel" class="tel">
                <img alt="电话号码" class="user-tel" src="@/assets/images/html/call_03.png">
                <span>{{order_info.contact_tel}}</span>
              </a>
            </div>
          </div>
          <div>
            <div class="one">
              <span>出行日期：</span>
              <em>{{$dateUtil.df(plan_info.depart_time)}}</em>
            </div>
            <div class="tow">
              <span>订单金额：</span>
              <i>{{order_info.total_amount | currency}}</i>
            </div>
            <div>
              <a
                @click="is_expansion=!is_expansion"
                href="javascript:void(0);"
                style="color: black;"
              >明细&nbsp;V</a>
            </div>
          </div>
          <transition>
            <div class="order-amount-info-table" v-show="is_expansion">
              <table>
                <tr>
                  <th id="price_categories">价格种类</th>
                  <th>单价</th>
                  <th>订购</th>
                  <th>应收金额</th>
                </tr>
                <tr v-for="(price_item, index) in price_list" v-if="price_list.length > 0">
                  <td class="text">{{price_item.name}}</td>
                  <td>{{price_item.price}}</td>
                  <td>{{price_item.num}}</td>
                  <td style="color:#313131;">{{price_item.total}}</td>
                </tr>
              </table>
            </div>
          </transition>
          <div class="order-result-route-info">
            <h2 class="order-info-h2" style="margin-top:40px;">收款信息</h2>
            <div>
              <div class="one">
                <span>应收金额：</span>
                <i>{{order_info.total_amount | money | currency}}</i>
              </div>
              <div class="tow">
                <span>已收金额：</span>
                <i>{{order_info.total_received_amount | money | currency}}</i>
              </div>
              <div class="tow">
                <span>欠款金额：</span>
                <i>{{order_info.total_amount | subtract(order_info.total_received_amount) | money | currency}}</i>
              </div>
            </div>
          </div>
          <div>
            <h2 class="order-info-h2" style="margin-top:40px;">固定信用额度</h2>
            <div class="one">
              <span>下单前可用：</span>
              <i>{{$number.formatStr($number.add(can_use_credit_amount, order_info.total_amount))}}</i>
            </div>
            <div class="tow">
              <span>本次使用：</span>
              <i>{{$number.formatStr(order_info.total_amount)}}</i>
            </div>
            <div>
              <span>下单后可用：</span>
              <i>{{$number.formatStr(can_use_credit_amount)}}</i>
            </div>
          </div>
        </div>
        <div class="order-result-error-button" v-if="$defines.is_allow_pay">
          <a
            @click="$pushByName('orderReceive',{'order_id':order_id,})"
            href="javascript:void(0);"
            v-if="$defines.is_allow_pay && $number.subtract(order_info.total_amount, order_info.total_received_amount) > 0"
          >
            <span>继续收款</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'orderReceiveResult',
  data () {
    return {
      is_expansion: false,
      order_id: 0,
      result: true,
      order_info: {},
      user_info: {},
      plan_info: {},
      order_nums: [],
      ticket_type: [],
      ticket_prices: [],
      order_additional_costs: [],
      advance_list: [],
      favorable_list: [],
      can_use_credit_amount: '',
      received_amount: '',
      price_list: []
    }
  },
  created () {
    this.order_id = this.$route.query.order_id
    this.result = this.$route.query.result
    this.can_use_credit_amount = this.$route.query.can_use_credit_amount
    this.received_amount = this.$route.query.received_amount

    const price_list = this.$sessionStorageUtil.get('price_list')
    if (price_list) {
      this.price_list = price_list
    }
    this.getData()
  },
  methods: {
    getData () {
      const url = 'order_info/order_detail/' + this.order_id
      const params = {}
      var orderDetail = this.$myGet(url, params)
      orderDetail.then(res => {
        this.order_info = res.response.data.orderInfo
        this.order_nums = res.response.data.orderNums
        this.ticket_type = res.response.data.ticketTypes
        this.ticket_prices = res.response.data.ticketPrices
        this.order_additional_costs = res.response.data.orderAdditionalCosts
        this.advance_list = res.response.data.advanceList
        this.favorable_list = res.response.data.favorableList
        this.user_info = res.response.data.userInfo
        this.plan_info = res.response.data.planInfo
      }).catch(err => {
        console.log('err=' + err)
      })
    }
  },
  computed: {},
}
</script>

<style lang="" scoped>
@import '../../assets/css/pages/customer/customer.css';
</style>


// WEBPACK FOOTER //
// src/pages/agent/orderReceiveResult.vue